import React, { useContext } from "react"
import ReactDOM from "react-dom"
import { BrowserRouter } from "react-router-dom"
import "./css/index.less"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import AuthContext, { AuthContextProvider } from "@/context/auth.context"
import Navigations from "@/routes"
import {QueryCache, QueryClient, QueryClientProvider} from "react-query"
import { Provider } from "react-redux"
import store from "@/redux/store"
import { message } from "antd"

const RestQC = () => {
  const { handleNeedsAuthentication } = useContext(AuthContext)

  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (err: any, query: any,) => {
        try {
          if ([401, 403].includes(err.request.status)) {
            handleNeedsAuthentication(
              true,
              location.pathname,
              async () => err.open(),
            )
          }
          if (err.request.status === 500 || err.request.status === 0) {
            message.error("Error connecting server")
          }
        } catch (e) {
          console.error("Error ", e)
        }
      }
    })
  })
    // defaultOptions: {
    //   queries: {
    //     ,
    //     cacheTime: 0,
    //     staleTime: 0,
    //     retry: false,
    //   },
    // },

  return (
    <QueryClientProvider client={queryClient}>
      <Navigations>
        <App />
      </Navigations>
    </QueryClientProvider>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthContextProvider>
        <BrowserRouter>
          <RestQC />
        </BrowserRouter>
      </AuthContextProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
